// @ts-ignore
import * as Levels from "url:../../Game/3d-object-files/**/*.glb";
import { HashMatrix } from "@incarnate/core";
import { Command } from "./CommandUtils";

const LEVELS_HASHMATRIX = new HashMatrix({
  hashMatrix: Levels,
  pathDelimiter: "/",
});

export const cleanLevelUrl = (url: string): string => {
  // IMPORTANT: Remove windows backslashes.
  return url.replace(/\\/g, "/").replace(/^\.\//g, "");
};

export const offsetRelativity = (baseUrl: string, url: string) => {
  baseUrl = cleanLevelUrl(baseUrl);
  url = cleanLevelUrl(url);

  return url.replace(baseUrl, "").replace(/^\//g, "");
};

export const resolveLevelUrl = (url: string, baseUrl?: string): string => {
  const normalizedUrl = baseUrl
    ? offsetRelativity(baseUrl, url)
    : cleanLevelUrl(url);
  const pathWithoutExtension = normalizedUrl.replace(/\.glb$/, "");

  return LEVELS_HASHMATRIX.getPath(pathWithoutExtension) as string;
};

export const loadLevelCommand: Command = (_mesh, userData, commandContext) => {
  const {
    levelContext: { setLevelUrl },
  } = commandContext;
  const { LoadLevel: loadLevel = [] } = userData;

  if (loadLevel && loadLevel.length > 0) {
    const [{ path: levelUrl = "" } = {}] = loadLevel;

    setLevelUrl(levelUrl);
  }
};
